module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrows-expand-4f138660.svg";